import { Observable, of as observableOf } from 'rxjs';
import { ContextMenuOption } from '../../models/context-menu-option';
import { DrRequestInfo } from '../../models/dr-request-info';
import { EntityType } from '../../models/enums';
import { NavigationInfo } from '../../models/navigation-info';
import { SecureObject } from '../../models/permission';
import * as _ from 'underscore';

export class GenericTreeNode extends SecureObject {
    name: string;
    entityType: EntityType;
    data: any;
    bundle: any;
    listingHandle: string;

    automationId = 'tree-node';
    customClasses = '';

    customNumber: number;
    customText: string;
    customColumn: string;
    customAllOptions: Array<any>;

    icon: string;
    iconColor: string;
    iconSecond: string;
    iconSecondColor: string;
    iconThird: string;
    iconThirdColor: string;
    iconExpanded: string;
    iconStringContent: string;
    iconOriginalColor: string;

    isSelectable = true;
    isExpandable: boolean;
    isExpanded: boolean;
    isExpandedOnSelect: boolean;
    isSortable: boolean;
    isSortedAlphabetically: boolean;
    hasCheckbox: boolean;
    isChecked: boolean;
    isCheckedOnSelect: boolean;
    looksDisabledUnchecked: boolean;
    hideCheckboxWhenBusy: boolean;
    hasExpanderPadding: boolean;
    hideExpander: boolean;
    isLoading: boolean;
    isDisabled: boolean;
    isButton: boolean;
    isTagDeletion: boolean;
    isMouseOver: boolean;
    getMoreOnSelectedNodeCallback: boolean;
    iconTitle: string;
    hideParent: boolean;
    hasFadedNodeName: boolean;
    isReefReviewProject: boolean;
    isRelativityProject: boolean;
    checkboxBeforeExpander: boolean;
    isCheckboxDisabled: boolean;
    isHeaderSelectable = false;
    isManualSelection? = false;

    level = 0;
    children = new Array<GenericTreeNode>();
    childPadding = 15;
    parent: GenericTreeNode;
    prevOldNode: GenericTreeNode;
    domId: string;

    navigationInfo: NavigationInfo;
    requestInfo: DrRequestInfo;
    secondRequestInfo: DrRequestInfo;
    buildRequestInfo: (item: GenericTreeNode) => void;
    preloadedData: Array<any>;
    loadOnClick = true;

    showContextMenuButton: boolean;
    contextMenuOptions: Array<ContextMenuOption>;
    getContextMenu: (data: any) => Array<ContextMenuOption>;
    hasContextMenuOpened: boolean;

    showHeaderButton: boolean;
    headerButtons: Array<ContextMenuOption>;

    onContextMenuAction: (item: GenericTreeNode, action: string) => void;

    filterBy: (value: GenericTreeNode, index: number, array: GenericTreeNode[]) => any;

    createChild = (item: any, handler?: any): GenericTreeNode => new GenericTreeNode({ name: item.name, data: item }, handler);

    constructor(value: Partial<GenericTreeNode>, handler?: any) {
        super();
        Object.assign(this, value);
        if (!this.onContextMenuAction && handler) {
            this.onContextMenuAction = handler;
        }
        if (this.automationId === 'tree-node') {
            if (this.data && this.data.handle) {
                this.automationId = 'injected-id-' + this.data.handle;
            } else {
                this.automationId = 'injected-name-id-' + this.name;
                console.warn('Creating a node with a name-based default automation ID. If names are not unique for this data type, there may be problems.');
                console.warn(this);
            }
        } else if (this.automationId.indexOf('[object Object]') > -1) {
            console.error('Creating a bad automation ID');
        }
    }

    isArchivedNode(): boolean {
        return this.data?.archived || this.data?.view?.archived;
    }

    getChildren(): Observable<GenericTreeNode[]> {
        return observableOf(this.filterBy ? this.children.filter(this.filterBy) : this.children);
    }

    setChildren = (data: Array<any>) => {
        if (data) {
            this.children = data.map((item, index) => {
                const child: GenericTreeNode = (item instanceof GenericTreeNode) ? item : this.createChild(item);
                child.parent = this;
                if (this.automationId) {
                    child.automationId = `${this.automationId}-${child.name}`;
                }
                return child;
            });
        }
    }

    canLoadData(): boolean {
        if (this.buildRequestInfo) {
            this.buildRequestInfo(this);
        }
        return Boolean(this.requestInfo && this.requestInfo.endpoint && this.requestInfo.data && this.requestInfo.responseName);
    }

    hasPreloadedData = (): boolean => {
        return Boolean(this.preloadedData && this.preloadedData.length > 0);
    }

}
